export default __webpack_public_path__ + "static/media/aj8.2cf37de7.png";